var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection-flow"},_vm._l((_vm.media),function(val,key){return _c('div',{key:key,staticClass:"flow-item"},[_c('div',[_c('img',{attrs:{"src":_vm.keyToImg(key),"alt":""}})]),_c('p',{staticClass:"name"},[_vm._v(_vm._s(key))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed2(val)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }